import React from 'react';

const Loader = () => {
    return (
        <div
            style={{
                display: 'flex',
                height: '100vh',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#f0f2f5' // Optional background color
            }}
        >
            <div
                style={{
                    width: '50px',
                    height: '50px',
                    border: '5px solid #0096a9',
                    borderTop: '5px solid transparent', // Creates the spinning effect
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}
            />
            <style>
                {`
                    @keyframes spin {
                        from { transform: rotate(0deg); }
                        to { transform: rotate(360deg); }
                    }
                `}
            </style>
        </div>
    );
};

export default Loader;
